/* LayerStore Discount campaign countdown and rotating top bar. */
(function () {
  var ROTATION_INTERVAL_MS = 10000;
  var TRANSITION_DURATION_MS = 320;

  if (window.LayerStoreDiscountTimer && window.LayerStoreDiscountTimer.initialized) {
    window.LayerStoreDiscountTimer.refresh();
    return;
  }

  function update(el) {
    var start = Date.parse(el.dataset.startAt);
    var end = Date.parse(el.dataset.endAt);
    if (isNaN(end)) return;
    var now = Date.now();
    var beforeStart = !isNaN(start) && now < start;
    var target = beforeStart ? start : end;
    var diff = Math.max(0, target - now);
    var d = Math.floor(diff / 86400000);
    var h = Math.floor((diff % 86400000) / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    var s = Math.floor((diff % 60000) / 1000);
    var pad = function (n) { return n < 10 ? "0" + n : "" + n; };
    var qD = el.querySelector("[data-d]");
    var qH = el.querySelector("[data-h]");
    var qM = el.querySelector("[data-m]");
    var qS = el.querySelector("[data-s]");
    var qLabel = el.querySelector("[data-campaign-phase-label]");
    if (qD) qD.textContent = pad(d);
    if (qH) qH.textContent = pad(h);
    if (qM) qM.textContent = pad(m);
    if (qS) qS.textContent = pad(s);
    if (qLabel) qLabel.textContent = beforeStart ? "Starts in" : "Ends in";

    var topbar = el.hasAttribute("data-campaign-topbar")
      ? el
      : el.closest("[data-campaign-topbar]");
    if (diff === 0 && !beforeStart) {
      el.classList.add("campaign-timer--expired");
    } else {
      el.classList.remove("campaign-timer--expired");
      if (topbar && topbar.dataset.topbarDismissed !== "true") {
        topbar.hidden = false;
        topbar.removeAttribute("data-campaign-pending");
      } else if (el.hasAttribute("data-campaign-pending")) {
        el.removeAttribute("data-campaign-pending");
      }
    }
  }

  function parseTopbarCampaigns(bar) {
    var raw = bar.getAttribute("data-campaign-topbar-campaigns");
    if (raw) {
      try {
        var parsed = JSON.parse(raw);
        if (Array.isArray(parsed) && parsed.length > 0) return parsed;
      } catch (e) {}
    }

    return [{
      campaign_id: bar.dataset.campaignId || "default",
      title: textOf(bar, "[data-campaign-topbar-title]"),
      subtitle: textOf(bar, "[data-campaign-topbar-subtitle]"),
      start_at: bar.dataset.startAt,
      end_at: bar.dataset.endAt,
    }];
  }

  function textOf(root, selector) {
    var node = root.querySelector(selector);
    return node ? node.textContent.trim() : "";
  }

  function campaignKey(campaign) {
    return String(campaign.campaign_id || campaign.end_at || "default");
  }

  function availableCampaigns(state) {
    var now = Date.now();
    return state.campaigns.filter(function (campaign) {
      var end = Date.parse(campaign.end_at);
      return !isNaN(end) && end > now;
    });
  }

  function applyCampaign(bar, campaign) {
    var title = bar.querySelector("[data-campaign-topbar-title]");
    var subtitle = bar.querySelector("[data-campaign-topbar-subtitle]");
    var titleText = campaign.title || "";
    var subtitleText = campaign.subtitle || "";

    if (title) {
      title.textContent = titleText;
      title.hidden = !titleText;
    }
    if (subtitle) {
      subtitle.textContent = subtitleText;
      subtitle.hidden = !subtitleText;
    }

    bar.dataset.campaignId = campaignKey(campaign);
    bar.dataset.startAt = campaign.start_at || "";
    bar.dataset.endAt = campaign.end_at || "";
    bar._layerStoreTopbarState.currentId = campaignKey(campaign);
    update(bar);
  }

  function showCampaign(bar, campaign, animate) {
    var state = bar._layerStoreTopbarState;
    var content = bar.querySelector(".campaign-topbar__content");
    if (!animate || !content) {
      applyCampaign(bar, campaign);
      return;
    }

    state.animating = true;
    content.classList.remove("campaign-topbar__content--entering");
    content.classList.add("campaign-topbar__content--leaving");

    window.setTimeout(function () {
      if (!bar.isConnected || state.dismissed) return;
      applyCampaign(bar, campaign);
      content.classList.remove("campaign-topbar__content--leaving");
      content.classList.add("campaign-topbar__content--entering");

      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          content.classList.remove("campaign-topbar__content--entering");
          window.setTimeout(function () {
            state.animating = false;
          }, TRANSITION_DURATION_MS);
        });
      });
    }, TRANSITION_DURATION_MS);
  }

  function advanceTopbar(bar) {
    var state = bar._layerStoreTopbarState;
    if (!state || state.animating || state.dismissed) return;
    var campaigns = availableCampaigns(state);
    if (campaigns.length === 0) {
      bar.hidden = true;
      return;
    }
    if (campaigns.length === 1) {
      if (state.currentId !== campaignKey(campaigns[0])) {
        showCampaign(bar, campaigns[0], true);
      }
      return;
    }

    var currentIndex = campaigns.findIndex(function (campaign) {
      return campaignKey(campaign) === state.currentId;
    });
    var nextIndex = currentIndex < 0 ? 0 : (currentIndex + 1) % campaigns.length;
    showCampaign(bar, campaigns[nextIndex], true);
  }

  function syncTopbar(bar) {
    var state = bar._layerStoreTopbarState;
    if (!state || state.dismissed) return;
    var campaigns = availableCampaigns(state);
    if (campaigns.length === 0) {
      bar.hidden = true;
      return;
    }
    var currentAvailable = campaigns.some(function (campaign) {
      return campaignKey(campaign) === state.currentId;
    });
    if (!currentAvailable && !state.animating) {
      showCampaign(bar, campaigns[0], true);
    }
  }

  function initTopbars() {
    document.querySelectorAll("[data-campaign-topbar]").forEach(function (bar) {
      if (bar.dataset.topbarReady === "true") return;
      bar.dataset.topbarReady = "true";
      var campaigns = parseTopbarCampaigns(bar);
      var campaignId = bar.dataset.campaignId || "default";
      var storageKey = "layerstore-discount-topbar-closed:" + campaignId;
      var state = {
        campaigns: campaigns,
        currentId: campaignId,
        animating: false,
        dismissed: false,
        intervalId: null,
      };
      bar._layerStoreTopbarState = state;

      try {
        if (window.localStorage.getItem(storageKey) === "1") {
          state.dismissed = true;
          bar.dataset.topbarDismissed = "true";
          bar.hidden = true;
          return;
        }
      } catch (e) {}

      var close = bar.querySelector("[data-campaign-topbar-close]");
      if (close) {
        close.addEventListener("click", function () {
          state.dismissed = true;
          bar.dataset.topbarDismissed = "true";
          bar.hidden = true;
          if (state.intervalId) window.clearInterval(state.intervalId);
          try {
            window.localStorage.setItem(storageKey, "1");
          } catch (e) {}
        });
      }

      if (campaigns.length > 1) {
        state.intervalId = window.setInterval(function () {
          advanceTopbar(bar);
        }, ROTATION_INTERVAL_MS);
      }
    });
  }

  function initDismissables() {
    document.querySelectorAll("[data-campaign-dismissable]").forEach(function (timer) {
      if (timer.dataset.dismissReady === "true") return;
      timer.dataset.dismissReady = "true";
      var campaignId = timer.dataset.campaignCloseId || timer.dataset.endAt || "default";
      var storageKey = "layerstore-discount-timer-closed:" + campaignId;
      try {
        if (window.localStorage.getItem(storageKey) === "1") {
          timer.hidden = true;
          return;
        }
      } catch (e) {}

      var close = timer.querySelector("[data-campaign-dismiss]");
      if (!close) return;
      close.addEventListener("click", function () {
        timer.hidden = true;
        try {
          window.localStorage.setItem(storageKey, "1");
        } catch (e) {}
      });
    });
  }

  function tick() {
    document.querySelectorAll("[data-campaign-timer]").forEach(update);
    document.querySelectorAll("[data-campaign-topbar]").forEach(syncTopbar);
  }

  function refresh() {
    initTopbars();
    initDismissables();
    tick();
  }

  window.LayerStoreDiscountTimer = {
    initialized: true,
    refresh: refresh,
  };
  refresh();
  window.setInterval(tick, 1000);
})();
